import { BookOpenCheckIcon, CalendarCheckIcon, FileTextIcon, FolderOpenIcon, ListChecksIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type BonusGroup = {
  heading: string;
  items: string[];
};

export type Bonus = {
  number: string;
  title: string;
  description: string;
  highlight?: string;
  items?: string[];
  groups?: BonusGroup[];
  cycleLabel?: string;
  cycle?: string[];
  benefit?: string;
  value: string;
  icon: LucideIcon;
  wide?: boolean;
};

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: '150 Geothermal Energy Classroom Activities & Challenges',
    description:
      '150 ready-to-use activity ideas organized into 10 thematic sections: geothermal energy fundamentals, geothermal geology and resources, drilling and well engineering, power generation technologies, heating and direct-use applications, environmental impacts and sustainability, economics and project development, advanced geothermal technologies, international geothermal applications, and integrated geothermal learning. Organized by difficulty level and topic.',
    benefit: 'Materials already designed for your classroom: saves hours every quarter.',
    value: 'USD 14',
    icon: FolderOpenIcon,
  },
  {
    number: '02',
    title: 'Geothermal Energy Teacher Assessment Kit',
    description:
      'Comprehensive assessment resources designed to evaluate student learning throughout a geothermal energy course. Includes:',
    items: [
      '150 open-ended assessment questions',
      '20 written assessment activities',
      '10 case-based assessments',
      'Suggested answers and assessment guidance',
      'Teacher grading recommendations',
      'Scientific reasoning and conceptual understanding assessments',
      'Classroom evaluation and learning progress guidance',
      'Formative and summative assessment strategies',
    ],
    benefit: 'Never build an exam from scratch under pressure again.',
    value: 'USD 14',
    icon: ListChecksIcon,
  },
  {
    number: '03',
    title: '100 Geothermal Energy Case Studies & Problem-Solving Scenarios',
    description:
      'A collection of 100 developed geothermal energy cases organized into 10 thematic sections: geothermal fundamentals, geology and exploration, drilling and well systems, geothermal power generation, heating and direct-use applications, environmental management and safety, economics and project development, advanced geothermal technologies, international geothermal applications, and integrated problem-solving.',
    benefit:
      'Students analyze facts, separate known information from assumptions, identify missing evidence, and develop justified technical solutions.',
    value: 'USD 14',
    icon: FileTextIcon,
  },
  {
    number: '04',
    title: 'Geothermal Energy Teacher Dictionary: 200 Essential Concepts Explained',
    description:
      'Comprehensive reference handbook covering 200 essential geothermal energy concepts organized into 10 categories: geothermal fundamentals, geology and Earth science, exploration and resource assessment, drilling and well engineering, power generation, heating and direct use, environment and sustainability, economics and project development, advanced technologies, and education and global applications. Includes terminology related to:',
    items: [
      'Geothermal Energy Fundamentals',
      'Geology and Earth Science',
      'Exploration and Resource Assessment',
      'Drilling and Well Engineering',
      'Power Generation Technologies',
      'Heating and Direct-Use Applications',
      'Environment and Sustainability',
      'Economics and Project Development',
      'Advanced Technologies and Innovation',
      'Educational and Global Applications',
    ],
    benefit: 'Project it in class and your students instantly understand complex geothermal energy concepts.',
    value: 'USD 14',
    icon: BookOpenCheckIcon,
  },
  {
    number: '05',
    title: 'Geothermal Energy Teacher Lesson Planning & Instructional Strategies Guide',
    description: 'A complete planning resource designed to help educators turn technical material into organized lessons.',
    highlight: 'Includes 10 Complete Detailed Lesson Plans + 15 Additional Lessons in 3 Teaching Sequences',
    groups: [
      {
        heading: 'The guide includes:',
        items: [
          'Foundations of Geothermal Energy Teaching',
          'Lesson Planning Principles',
          'Inquiry-Based and Problem-Based Teaching Strategies',
          'Techniques for Explaining Complex Geothermal Concepts',
          'Classroom Management and Student Engagement',
          'Differentiated Instruction for Different Educational Levels',
          '3 Complete Teaching Sequences (each containing 5 integrated lessons)',
          'Assessment and Learning Improvement Strategies',
          'Final Teaching Recommendations',
        ],
      },
      {
        heading: 'Each lesson structure includes:',
        items: [
          'Learning Objectives',
          'Key Concepts',
          'Lesson Opening',
          'Core Explanation',
          'Guided Classroom Task',
          'Student Questions',
          'Understanding Check',
          'Common Misconceptions',
          'Lesson Connections',
        ],
      },
    ],
    cycleLabel: 'The guide follows a structured teaching cycle:',
    cycle: ['Plan', 'Introduce', 'Explain', 'Connect', 'Apply', 'Question', 'Assess', 'Review', 'Integrate'],
    value: 'USD 14',
    icon: CalendarCheckIcon,
    wide: true,
  },
];
